import _t from 'i18n!nls/audit';

export type ProgramType = (typeof PROGRAM_TYPES)[keyof typeof PROGRAM_TYPES];

export const PROGRAM_TYPES = {
  specialization: 'Specialization',
  professionalCertificate: 'Professional Certificate',
  mixAndMatch: 'Mix and Match',
  course: 'Course',
} as const;

export const getProgramTypeString = () => ({
  [PROGRAM_TYPES.specialization]: _t('Specialization'),
  [PROGRAM_TYPES.professionalCertificate]: _t('Professional Certificate'),
  [PROGRAM_TYPES.course]: _t('course'),
});

export const getLockedAssignmentCoverHeaderText = (programType: ProgramType) => {
  if (programType !== PROGRAM_TYPES.mixAndMatch) {
    return _t('Upgrade to this #{programTypeString} for the full learning experience', {
      programTypeString: getProgramTypeString()[programType],
    });
  }

  return _t('Upgrade now for the full learning experience');
};

export const getLockedAssignmentBannerHeaderText = (programType: ProgramType) => {
  if (programType !== PROGRAM_TYPES.mixAndMatch) {
    return _t('Upgrade to this #{programTypeString} to submit assessments and more', {
      programTypeString: getProgramTypeString()[programType],
    });
  }

  return _t('Upgrade now to submit assessments and more');
};

export const getUpsellBannerHeaderText = (programType: ProgramType) => {
  if (programType !== PROGRAM_TYPES.mixAndMatch) {
    return _t('Upgrade to this #{programTypeString}', {
      programTypeString: getProgramTypeString()[programType],
    });
  }

  return _t('Upgrade now for the full learning experience');
};

export const getAuditFlowCtaText = (showFreeTrialCopy: boolean = true) => {
  return showFreeTrialCopy ? _t('Start #{numberOfDays}-day free trial', { numberOfDays: 7 }) : _t('Unlock full access');
};

export const getUpsellQuoteText = () =>
  _t(
    '“I got into two summer internships and received a job offer for a data scientist role by sharing my Coursera certificates.“'
  );
